import { Box, Skeleton, Typography } from '@mui/material';
import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { EasTableWithoutFilter } from 'ui/EasTableWithoutFilter';
import { THandleAction } from 'ui/EasTable/types';
import { TPageResponse } from 'redux/types';
import { selectOrderDetails, selectOrderDetailsLoading } from 'redux/reducers/euDdp/selectors';
import { tableStructure } from './tableStructure';
import { TShipmentDetailsTableItem } from './types';

export const ShipmentDetails: FC = () => {
	const order = useSelector(selectOrderDetails);
	const orderIsLoading = useSelector(selectOrderDetailsLoading);

	const paymentCurrency = order?.order?.payment_currency ?? 'EUR';

	const handleAction: THandleAction = useCallback(() => {}, []);

	const tableData: TPageResponse<TShipmentDetailsTableItem> | null =
		order && order.order_shipment
			? (() => {
					const shipment = order.order_shipment;
					const rows: TShipmentDetailsTableItem[] = [
						{
							id: 0,
							name: 'Merchandise Cost',
							currency: paymentCurrency,
							original: shipment.initial_merch_amount,
							preliminary: shipment.preliminary_merch_amount,
							actual: shipment.actual_merch_amount,
							toBePaid: null,
						},
						{
							id: 1,
							name: 'Delivery Cost',
							currency: paymentCurrency,
							original: shipment.initial_delivery_cost,
							preliminary: shipment.preliminary_delivery_cost,
							actual: shipment.actual_delivery_cost,
							toBePaid: null,
						},
						{
							id: 2,
							name: 'Customs Duties',
							currency: paymentCurrency,
							original: shipment.initial_duties,
							preliminary: shipment.preliminary_duties,
							actual: shipment.actual_duties,
							toBePaid: shipment.actual_eur_duties,
						},
						{
							id: 3,
							name: 'VAT Amount',
							currency: paymentCurrency,
							original: shipment.initial_vat,
							preliminary: shipment.preliminary_vat,
							actual: shipment.actual_vat,
							toBePaid: shipment.actual_eur_vat,
						},
						{
							id: 4,
							name: 'Customs Procedures Processing Fee',
							currency: paymentCurrency,
							original: null,
							preliminary: null,
							actual: shipment.actual_customs_fee,
							toBePaid: shipment.actual_eur_customs_fee,
						},
						{
							id: 5,
							name: 'EAS DDP Shipping Cost',
							currency: paymentCurrency,
							original: null,
							preliminary: null,
							actual: null,
							toBePaid: shipment.actual_eur_shipping_price,
						},
					];
					return {
						data: rows,
						pageNumber: 1,
						pageSize: rows.length,
						totalCount: rows.length,
					};
				})()
			: null;

	if (orderIsLoading || !order) {
		return <Skeleton variant="rectangular" height="288px" sx={{ borderRadius: '12px', mb: 2 }} />;
	}

	return (
		<Box sx={{ mb: 2 }}>
			<EasTableWithoutFilter<TShipmentDetailsTableItem>
				tableStructure={tableStructure}
				items={tableData}
				itemsIsLoading={orderIsLoading}
				handleAction={handleAction}
			>
				<Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
					<Typography sx={{ fontSize: 14 }} color="primary" component="h2" fontWeight="bold">
						Shipment Details
					</Typography>
				</Box>
			</EasTableWithoutFilter>
		</Box>
	);
};
